import * as React from 'react';

import AuthCallback from './AuthCallback/AuthCallback';
import Dashboard from './Dashboard/Dashboard';

export { AuthCallback, Dashboard };

export const AddressBook = React.lazy(
  () => import(/* webpackChunkName: "page-address-book" */ './AddressBook/AddressBook'),
);
export const Automations = React.lazy(
  () => import(/* webpackChunkName: "page-automations" */ './Automations/Automations'),
);
export const BusinessReasons = React.lazy(
  () => import(/* webpackChunkName: "page-business-reasons" */ './BusinessReasons/BusinessReasons'),
);
export const Campaigns = React.lazy(() => import(/* webpackChunkName: "page-campaigns" */ './Campaigns/Campaigns'));
export const HubspotAppIntegration = React.lazy(
  () => import(/* webpackChunkName: "page-hubspot-app" */ './HubspotAppIntegration/HubspotAppIntegration'),
);
export const Integrations = React.lazy(
  () => import(/* webpackChunkName: "page-integrations" */ './Integrations/Integrations'),
);
export const Inventory = React.lazy(() => import(/* webpackChunkName: "page-inventory" */ './Inventory/Inventory'));
export const BulkSendManager = React.lazy(
  () => import(/* webpackChunkName: "page-bulk-send-manager" */ './BulkSendManager/BulkSendManager'),
);

export const OneLinkManager = React.lazy(
  () => import(/* webpackChunkName: "page-one-link-manager" */ './OneLinkManager/OneLinkManager'),
);
export const Organizations = React.lazy(
  () => import(/* webpackChunkName: "page-organizations" */ './Organizations/Organizations'),
);
export const Reports = React.lazy(() => import(/* webpackChunkName: "page-reports" */ './Reports/Reports'));
export const SignatureSetup = React.lazy(
  () => import(/* webpackChunkName: "page-signature-setup" */ './SignatureSetup/SignatureSetup'),
);
export const SuggestGift = React.lazy(
  () => import(/* webpackChunkName: "page-suggest-gift" */ './SuggestGift/SuggestGift'),
);
export const Templates = React.lazy(() => import(/* webpackChunkName: "page-templates" */ './Templates/Templates'));
export const Users = React.lazy(() => import(/* webpackChunkName: "page-users" */ './Users/Users'));
export const ClaimLinkTemplatesPage = React.lazy(() =>
  import(/* webpackChunkName: "page-claim-link-templates" */ './ExperienceManager/ClaimLinkTemplatesPage').then(
    (m) => ({
      default: m.ClaimLinkTemplatesPage,
    }),
  ),
);
export const CustomMessageTemplatesPage = React.lazy(() =>
  import(/* webpackChunkName: "page-custom-message-templates" */ './ExperienceManager/CustomMessageTemplatesPage').then(
    (m) => ({ default: m.CustomMessageTemplatesPage }),
  ),
);
export const EmailTemplatesPage = React.lazy(() =>
  import(/* webpackChunkName: "page-email-templates" */ './ExperienceManager/EmailTemplatesPage').then((m) => ({
    default: m.EmailTemplatesPage,
  })),
);
